import { EternolDB } from "../lib/db/index.js";
import { ArmyData } from "../lib/db/types.js";
import { AbilityDef } from "./ability.js";
import { KeywordDef } from "./keyword.js";
import { UnitProfile } from "./unit.js";

export type RulesetData = {
  version: string;
  max_army_cost: number;
  min_army_size: number;
  max_army_size: number;
  min_unit_cost: number;
  unit_profiles: UnitProfile[];
  keywords: KeywordDef[];
  abilities: AbilityDef[];
};

export class Ruleset {
  readonly version: string;
  readonly defaultUnitProfile: UnitProfile;
  readonly unitProfiles: Map<string, UnitProfile>;
  readonly keywordDefs: Map<string, KeywordDef>;
  readonly maxArmyCost: number;
  readonly minArmySize: number;
  readonly maxArmySize: number;
  readonly minUnitCost: number;
  readonly data: RulesetData;

  // TODO: This should be handled differently
  private _db?: EternolDB;

  constructor(data: RulesetData, db?: EternolDB) {
    this._db = db;
    this.data = data;

    this.version = data.version;
    this.maxArmyCost = data.max_army_cost;
    this.minArmySize = data.min_army_size;
    this.maxArmySize = data.max_army_size;
    this.minUnitCost = data.min_unit_cost;

    const defaultUnitProfile = data.unit_profiles.at(0);
    if (!defaultUnitProfile) {
      throw new Error("At least one unit profile must be provided.");
    }
    this.defaultUnitProfile = defaultUnitProfile;
    this.unitProfiles = new Map(data.unit_profiles.map((u) => [u.id, u]));

    this.keywordDefs = new Map(data.keywords.map((k) => [k.id, k]));
  }

  get db() {
    const db = this._db;
    if (!db) {
      throw new Error("Database not connected to ruleset.");
    }
    return db;
  }

  get abilityDefs() {
    return new Map(this.data.abilities.map((a) => [a.id, a]));
  }

  get unitOrderByProfileId() {
    return new Map(this.data.unit_profiles.map((u, i) => [u.id, i]));
  }

  async createArmy(
    data: Pick<ArmyData, "name" | "description"> &
      Pick<Partial<ArmyData>, "units" | "keywords" | "theme">,
  ) {
    return this.db.createArmy({
      ...data,
      ruleset_version: this.version,
    });
  }
}
